import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { CONSUMER_URL } from "../../../../helpers/variables";
import {
  Autocomplete,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { Add } from "@mui/icons-material";
import { useLoaderData } from "react-router-dom";
import AddVendor from "../../../AddVendor";

export const Vendor = ({ invoice }) => {
  const { client_url, nimbleAuthID } = useLoaderData();
  const { values, setFieldValue, touched, errors, handleBlur } =
    useFormikContext();
  const { property } = values;

  const [vendorList, setVendorList] = useState([]);
  const [openAddVendor, setAddVendor] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchVendorList();
  }, [property]);

  async function fetchVendorList() {
    setVendorList([]);
    setFieldValue("vendor", null);

    if (!property) return;

    let url = `${CONSUMER_URL}/vendors_list?corporation_id=${encodeURIComponent(
      property["corporationID"]
    )}&client_url=${encodeURIComponent(client_url)}&name=${encodeURIComponent(
      invoice["vendor_name"]
    )}`;

    setLoading(true);
    let res = await fetch(url);

    if (res.status === 200) {
      let { vendor, vendor_list } = await res.json();
      setVendorList(vendor_list);
      setFieldValue("vendor", vendor);

      if (!vendor) {
        enqueueSnackbar(`Cant find vendor with ${invoice["vendor_name"]}`, {
          variant: "warning",
        });
      }
    } else {
      let data = await res.text();
      enqueueSnackbar(data, { variant: "error" });
    }
    setLoading(false);
  }

  return (
    <>
      {loading ? (
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <CircularProgress size={35} />
        </Box>
      ) : (
        <Autocomplete
          value={
            vendorList.find((i) => i["id"] === values["vendor"]?.["id"]) || null
          }
          size="small"
          options={vendorList}
          getOptionDisabled={(option) => option["status"] !== 1}
          getOptionLabel={(option) => option.name}
          onChange={(_, v) => setFieldValue("vendor", v)}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Vendors"
              required
              error={touched.vendor && Boolean(errors.vendor)}
              helperText={touched.vendor && errors.vendor}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <InputAdornment>
                    {nimbleAuthID && (
                      <Tooltip title={"Add vendor"} arrow>
                        <IconButton
                          size="small"
                          onClick={() => setAddVendor(true)}
                        >
                          <Add fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                    {params.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
            />
          )}
          loading={vendorList.length === 0}
        />
      )}

      <Dialog open={openAddVendor} fullScreen>
        <DialogContent sx={{ p: 0 }}>
          <AddVendor
            closeCallback={() => {
              setAddVendor(false);
              fetchVendorList();
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
